// extracted by mini-css-extract-plugin
export default {"table":"Table_table__gQw20","empty":"Table_empty__t5wkm","striped":"Table_striped__E6mzw","hoverable":"Table_hoverable__PbLG-","compact":"Table_compact__M2ggF"};